import { render } from "./DataviewFiltersDropdown.vue?vue&type=template&id=b7f06a12"
import script from "./DataviewFiltersDropdown.vue?vue&type=script&lang=js"
export * from "./DataviewFiltersDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__